import { render } from "./ProspectFirmology.vue?vue&type=template&id=47ebbbb6"
import script from "./ProspectFirmology.vue?vue&type=script&lang=js"
export * from "./ProspectFirmology.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__